import CryptoJS from "crypto-js";

const SECRET_KEY = "j5*k.9S8W6*(/OG5#1O1Dfp5z9/3U5dlsern6hU49Z95FQyn7ab9r5j6k3";

const crypt = (value, type) => {
	let response;

	if (type === "decrypt") {
		response = CryptoJS.AES.decrypt(value, SECRET_KEY).toString(
			CryptoJS.enc.Utf8
		);
	} else if (type === "crypt") {
		response = CryptoJS.AES.encrypt(value, SECRET_KEY).toString();
	}

	return response;
};

const API_CRYPT_KEY = "SZS!st3m4s@2025#K3y";

export const encryptApiKey = (key) => {
	if (!key) return "";
	return CryptoJS.AES.encrypt(key, API_CRYPT_KEY).toString();
};

export const decryptApiKey = (cryptKey) => {
	if (!cryptKey) return "";
	try {
		const bytes = CryptoJS.AES.decrypt(cryptKey, API_CRYPT_KEY);
		return bytes.toString(CryptoJS.enc.Utf8);
	} catch (e) {
		return cryptKey;
	}
};

export default crypt;
